import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import TopSection from './TopSection'
import BottomSection from './BottomSection'
import TopDestinationList from 'components/Common/TopDestinationsList/TopDestinationList'
import { useLocation } from 'react-router-dom'
import config from 'constants/config'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'
import Divider from 'LuxKit/Divider'
import { rem } from 'polished'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import AgentHubFooter from './agentHub/AgentHubFooter'
import CookieSettingsLink from 'components/Consent/CookieSettingsLink'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const SUPPORT_PAGE_ROUTE = '/:regionCode/support'

const Container = styled.footer`
  @media print {
    /* Hide footer entirely in print */
    display: none;

    /* Prevent URL suffixes on links if any nested content remains */
    a[href]:after {
      content: "";
    }
  }
`

const StyledLayoutContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
`

const TopSectionWrapper = styled(TopSection)`
  padding-bottom: ${rem(44)};
  padding-top: ${rem(44)};
`

function Footer() {
  const [footerRef, footerInView] = useInView({
    triggerOnce: true, // Load it once and keep it loaded
    rootMargin: '500px', // Trigger 500px before the component is reached
  })

  const showAgentHubFooter = config.agentHub.isEnabled
  const location = useLocation()
  const isSupportPage = !!matchLocaleAwarePath(location.pathname, { path: SUPPORT_PAGE_ROUTE, exact: true })
  const isHomePage = !!matchLocaleAwarePath(location.pathname, { path: '/:regionCode', exact: true })

  return (
    <Container className="PageFooter" ref={footerRef} data-testid="footer">
      <Pane background="light-background">
        {showAgentHubFooter && <AgentHubFooter />}
        {!showAgentHubFooter && (
          <>
            <Pane>
              {isHomePage && <TopDestinationList />}
              {footerInView && !isSupportPage && <StyledLayoutContainer>
                <VerticalSpacer gap={40}>
                  <Divider kind="primary" />
                  <TrustIndicatorSection />
                  <Divider kind="primary" />
                </VerticalSpacer>
                <TopSectionWrapper />
              </StyledLayoutContainer>}
            </Pane>
            {footerInView && <BottomSection />}
            {/* Help-column link mounts with BottomSection, which waits until the footer is near the viewport. */}
            {!footerInView && <CookieSettingsLink variant="inline" />}
          </>
        )}
      </Pane>
    </Container>
  )
}

export default Footer
